import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-79b2df62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex col",
  style: {"width":"400px"}
}
const _hoisted_2 = { class: "flex col" }
const _hoisted_3 = { class: "flex grow justify-between" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "blue-container flex col g24" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted bold" }, "Nombre maximum d'appareils ", -1))
const _hoisted_7 = { class: "flex col" }
const _hoisted_8 = { class: "text-muted f12 no-mobile" }
const _hoisted_9 = { class: "flex grow justify-end" }
const _hoisted_10 = { class: "flex col g0" }
const _hoisted_11 = { class: "text-muted f12 no-mobile" }
const _hoisted_12 = { class: "text-muted f12 no-mobile" }
const _hoisted_13 = { class: "bold" }
const _hoisted_14 = { class: "flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeNumberPicker = _resolveComponent("SeNumberPicker")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_WideCard = _resolveComponent("WideCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      ref: "deviceModal",
      title: "Devices"
    }, {
      default: _withCtx(() => [
        (_ctx.currentDevice != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_ToggleSwitch, { ref: "darkMode" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("dark-mode")), 1)
                ]),
                _: 1
              }, 512),
              _createVNode(_component_ToggleSwitch, { ref: "slowInternet" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("slow-internet")), 1)
                ]),
                _: 1
              }, 512),
              _createVNode(_component_ToggleSwitch, { ref: "audioTaskReminders" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("audio-reminder")), 1)
                ]),
                _: 1
              }, 512),
              _createVNode(_component_ToggleSwitch, { ref: "rotationLock" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("rotation-lock")), 1)
                ]),
                _: 1
              }, 512),
              _createVNode(_component_ToggleSwitch, { ref: "preventScreenLock" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("prevent-screen-lock")), 1)
                ]),
                _: 1
              }, 512),
              _createVNode(_component_SeButton, {
                class: "w100",
                onClick: _ctx.closeDeviceModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("close")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Lang.getI18N("devices")), 1),
        _createVNode(_component_SeButton, {
          ref: "saveBtn",
          onClick: _ctx.saveClick,
          icon: "ico/save.svg"
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.role != _ctx.Role.Distributor && _ctx.role != _ctx.Role.Admin,
          class: "flex align-center justify-between",
          style: {"background-color":"white","border-radius":"24px","padding":"12px"}
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createVNode(_component_SeNumberPicker, {
              onChanged: _ctx.onDeviceCountChanged,
              min: 1,
              max: 30,
              placeholder: "Maximum devices",
              modelValue: _ctx.state.store.maximum_devices,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.store.maximum_devices) = $event))
            }, null, 8, ["onChanged", "modelValue"])
          ]),
          _: 1
        }, 8, ["locked"]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (device) => {
            return (_openBlock(), _createBlock(_component_WideCard, {
              onClick: () => _ctx.onDeviceClick(device),
              title: device.name,
              icon: "ico/device-gray.svg"
            }, {
              subtitle: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(device.device_model), 1)
              ]),
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, "Dernière connexion : " + _toDisplayString(_ctx.DateUtils.formatDateWithTime(device.last_connexion)), 1),
                    _createElementVNode("span", _hoisted_12, [
                      _createTextVNode("Version : "),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(device.app_version), 1)
                    ])
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_SeFadeButton, {
                    onClick: [
                      _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                      () => _ctx.removeDevice(device)
                    ],
                    icon: "/ico/trash.svg"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 2
            }, 1032, ["onClick", "title"]))
          }), 256))
        ])
      ])
    ])
  ], 64))
}